import script from "./ClientsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientsList.vue?vue&type=script&setup=true&lang=ts"

import "./ClientsList.vue?vue&type=style&index=0&id=648dbf36&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-648dbf36"]])

export default __exports__